import { createAsyncThunk } from "@reduxjs/toolkit";
import ContentAPI, { ContentRequest, ContentResponse, GenerateContentType, ImproveContentRequest} from "../api/Content";

export const createContent = createAsyncThunk<
    ContentResponse,
    ContentRequest,
    {rejectValue: void}
>(
    'content/create',
    async (request, {rejectWithValue}) => {
        try {
            return await ContentAPI.create(request);
        } catch(error) {
            console.error(error);
            return rejectWithValue()
        }
    }
)

export const generateContentThunk = createAsyncThunk<
  ContentResponse,
  { caseId: string; contentType: GenerateContentType },
  { rejectValue: void }
>(
  "content/generate",
  async ({ caseId, contentType }, { rejectWithValue }) => {
    try {
      return await ContentAPI.generate(caseId, contentType);
    } catch (error) {
      console.error("Failed to generate content:", error);
      return rejectWithValue();
    }
  }
);

export const improveContentThunk = createAsyncThunk<
  ContentResponse,
  ImproveContentRequest,
  { rejectValue: void }
>(
  "content/improve",
  async ({ content }, { rejectWithValue }) => {
    try {
      return await ContentAPI.improve({ content });
    } catch (error) {
      console.error("Failed to improve content:", error);
      return rejectWithValue();
    }
  }
);
